import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { filtered } from "../features/filters/filterSlice";

export default function Project({ project }) {
  const [checked, setChecked] = useState(true);
  const { id, projectName, colorClass } = project;
  const dispatch = useDispatch();

  const handleCheck = () => {
    setChecked(!checked);
    dispatch(filtered({ checked: !checked, data: project }));
  };
  useEffect(() => {}, [checked]);
  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        checked={checked}
        onChange={handleCheck}
        className={colorClass}
      />
      <p className="label">{projectName}</p>
    </div>
  );
}
